import { About as ImportAbout } from "./about";
import { IpConfigOnReboot as ImportIpConfigOnReboot } from "./ipConfigOnReboot";
import { State as ImportState } from "./state";
import { AlertsRecent as ImportAlertsRecent } from "./alertsRecent";
import { Unix as ImportUnix } from "./unix";
import { Rtc as ImportRtc } from "./rtc";
import { Dispatch } from "redux";
import * as ImportEpics from "./epics";
import * as ImportReducers from "./state/reducers";

export namespace Common {
  export type State = ImportState;
  export const Epics = ImportEpics.default;
  export const Reducer = ImportReducers.default;
  export import About = ImportAbout;
  export import IpConfigOnReboot = ImportIpConfigOnReboot;
  export import AlertsRecent = ImportAlertsRecent;
  export import Unix = ImportUnix;
  export import Rtc = ImportRtc;

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      dispatch: {
        about: About.Actions.bindDispatchProps(dispatch),
        ipConfigOnReboot: IpConfigOnReboot.Actions.bindDispatchProps(dispatch),
        alertsRecent: AlertsRecent.Actions.bindDispatchProps(dispatch),
        unix: Unix.Actions.bindDispatchProps(dispatch),
        rtc: Rtc.Actions.bindDispatchProps(dispatch)
      }
    };
  };
}
export default Common;
